<template>
  <bm-btn
    button-type="ghost"
    v-bind="$attrs"
    :data-qa="expanded ? $m.keys.less : $m.keys.more"
    @click="toggle"
    >{{ expanded ? lessTextOverride || $m.less : moreTextOverride || $m.more }}
    <v-icon v-if="!expanded">expand_more</v-icon>
    <v-icon v-if="expanded">expand_less</v-icon>
  </bm-btn>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BmBtnExpand",
  model: {
    prop: "expanded",
    event: "change",
  },
  props: {
    moreTextOverride: {
      type: String,
      required: false,
      default: null,
    },
    lessTextOverride: {
      type: String,
      required: false,
      default: null,
    },
    expanded: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, context) {
    return {
      toggle: () => {
        context.emit("change", !props.expanded);
      },
    };
  },
});
</script>
